import styled from 'styled-components';
import { cssColorValue } from '@spotify-internal/encore-web';

export const ModeToggleText = styled.div`
  position: absolute;
  right: 0;
  padding-bottom: 8px;
  transform: translateY(-100%);
`;

export const TextEditorWrapper = styled.div(
  (props: { isShowingError: boolean; isUsingKeyboard: boolean }) => `
  border-radius: 4px;
  border: 0;
  box-shadow: inset 0 0 0 1px ${cssColorValue(
    props.isShowingError ? 'essentialNegative' : 'essentialSubdued'
  )};
  overflow: hidden;
  outline: 0;
  background: ${cssColorValue('backgroundBase')};

  &:hover {
    box-shadow: inset 0 0 0 1px ${cssColorValue(
      props.isShowingError ? 'essentialNegative' : 'essentialBase'
    )};
  }
  &:focus, &:focus-within {
    box-shadow: inset 0 0 0 ${
      props.isUsingKeyboard ? '3px' : '1.5px'
    } ${cssColorValue(
    props.isShowingError ? 'essentialNegative' : 'essentialBase'
  )};
  }
 
  .public-DraftEditorPlaceholder-root {
    position: absolute;
    color: ${cssColorValue('textSubdued')};
    font-weight: normal;
    font-size: 1rem;
    padding: 0;
    pointer-events: none;
  }

  .public-DraftEditor-content {
    min-height: 272px;
  }
`
);

export const Container = styled.div`
  position: relative;
`;
